export interface SpamNumberServiceGetAllParams {
    page?: number;
    per_page?: number;
    order_by?: string;
    search?: string;
}
